import DeleteSession from '@/connection/sessions/delete-session';
import { RootState } from '@/store/main';
import { serializeError } from '@/store/utils/serialize-error';
import convertProjectTypeBasedOnChannelType from '@/utils/new-project-helpers/convert-project-type-based-on-channel-type';
import { selectUserChannel } from '../../user/selectors';
import { ProjectStateReducerCreator } from '../types';

const deleteSessionReducer = (create: ProjectStateReducerCreator) => {
  return create.asyncThunk(
    async ({ projectUuid, sessionId }: { projectUuid: string; sessionId: number }, { rejectWithValue, getState }) => {
      try {
        const result = await DeleteSession({
          eventUuid: projectUuid,
          sessionID: sessionId,
        });

        if ('error' in result) {
          console.error('deleteSession error', result.error);
          return rejectWithValue(serializeError(result.error));
        }

        // if we are deleting the second last session and reverting to single session,
        // we need to set the event type to match the channel project type, so we pass it down
        const state = getState() as RootState;
        const userChannel = selectUserChannel(state);

        if (!userChannel) {
          console.error('No user channel found');
          return rejectWithValue('No user channel found');
        }

        return {
          session: result.session,
          channelProjectType: convertProjectTypeBasedOnChannelType({ channel: userChannel }),
        };
      } catch (e) {
        console.error(e);
        return rejectWithValue(serializeError(e));
      }
    },
    {
      fulfilled: (state, action) => {
        if (state.workingProject) {
          state.workingProject.sessions = state.workingProject.sessions?.filter(
            (s) => s.session !== action.payload.session
          );
          // if there is only one session left, we set the event type to be the channel type
          // this happens in the api, so here we are just syncing the state
          if (state.workingProject.sessions.length === 1 && action.payload.channelProjectType) {
            state.workingProject.event_type = action.payload.channelProjectType;
          }
        }
        state.deletingSession = false;
      },
      pending: (state) => {
        state.deletingSession = true;
      },
      rejected: (state) => {
        state.deletingSession = false;
      },
    }
  );
};

export default deleteSessionReducer;
